<ul class="submenu-list">
    <li (click)="change_route('/dashboard')">My Account</li>
    <li (click)="change_route('/profile')">Profile</li>
    <li *ngIf="menu_type == 'profile'" (click)="change_route('/store-detail')">Store Details</li>
    <li *ngIf="menu_type == 'profile'" (click)="change_route('/billing')">Biling</li>
    <li (click)="logout()">Logout</li>
</ul>